export default __webpack_public_path__ + "static/3_screen-3c845552655f30d5c947ed83893848c3.png";